import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function SkeletonInfoBalance() {
  return (
    <div className={styles['estimated-balance']}>
      <span className={styles['estimated-balance__title']}>
        <div className={skeleton.info}>
          <div className={skeleton.text} />
          <div className={skeleton.chevron} />
        </div>
      </span>{' '}
      <span className={styles['estimated-balance__value']}>
        <div className={skeleton.text} />
      </span>
    </div>
  );
}
